import { connect } from 'react-redux';
import LookaheadTagDialog from './LookaheadTagDialog'
import { styles } from '../../containers/dockPadStyle'
import { compose } from 'redux';
import { withStyles } from '@material-ui/core';
import { lookaheadActions } from '../../actions/lookahead.actions';

import { 
    getConstraints, 
    getTradesSelectList, 
    getConstraintSelectList, 
    getTrades,
} from '../../selectors/phaseplan.selector'

import {
    getLookaheadTagSelectList,
    getLookaheadTagLocationsSelectList,
    getLookaheadTagId,
    getLookaheadTag,
    getLookaheadTrades,
    getLookaheadTradeSelectList,
    isNewLookaheadTag,
    getTagDate,
    getRow,
} from '../../selectors/lookahead.selector'

import { isLookaheadTagDialogOpen } from '../../selectors/dialog.selector'
import { getProjectId } from '../../selectors/project.selector';
import { alertActions } from '../../actions/alert.actions';
import { LookaheadTag } from '../../models/LookaheadTag';
import { ThunkDispatch } from 'redux-thunk';
import { getUserTrades } from '../../selectors/trade.selector';
import { isAdmin } from '../../selectors/user.selector';

const mapStateToProps = (state: any) => ({
    isLookaheadTagDialogOpen: isLookaheadTagDialogOpen(state),
    tradesSelectList: getLookaheadTradeSelectList(state),
    tagSelectList: getLookaheadTagSelectList(state),
    tagLocationsSelectList: getLookaheadTagLocationsSelectList(state),
    constraintSelectList: getConstraintSelectList(state),
    projectId: getProjectId(state),
    trades:  getLookaheadTrades(state),
    tagToEdit: getLookaheadTag(state),
    tagToEditId: getLookaheadTagId(state),
    isNewTag: isNewLookaheadTag(state),
    constraints: getConstraints(state),
    tagDate: getTagDate(state),
    row: getRow(state),
    userTrades: getUserTrades(state),
    isAdmin: isAdmin(state),


});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => ({
    closeTagDialogValue: () => dispatch(lookaheadActions.lookaheadDialogClose()),
    submitTagValue: (tag:LookaheadTag, newConstraints: Record<string, object>, tagId?: string, tagDate?: string | null, row?: number | null, duration?: number | null) => 
        dispatch(lookaheadActions.saveTag( tag, newConstraints, tagId, tagDate, row, duration)),
    submitTagValueIsMilestone: (tag:LookaheadTag, newConstraints: Record<string, object>, tagId?: string) => 
        dispatch(lookaheadActions.saveTagIsMilestone( tag, newConstraints, tagId)),
    errorAlert: (message: string) => dispatch(alertActions.error(message))
});


export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles, { withTheme: true })
)(LookaheadTagDialog)


// WEBPACK FOOTER //
// ./src/components/Dialogs/LookaheadTagDialogContainer.ts